import React from 'react'

const ViewSquare = () => (
  <svg viewBox="0 0 22 22" width="22px" height="22px">
    <g fill="none" stroke="#121212" strokeMiterlimit="10">
      <rect height="22" rx="2" stroke="none" width="22" />
      <rect fill="none" height="21" rx="1.5" width="21" x=".5" y=".5" />
    </g>
    <rect fill="#121212" height="16" rx="2" width="16" x="3" y="3" />
  </svg>
)

export default ViewSquare
